<template>
  <div class="skelton-loader">
    <v-sheet class="pa-3" v-if="isLoading">
      <v-skeleton-loader class="mx-auto" :type="type" :loading="isLoading" />
    </v-sheet>
  </div>
</template>

<script>
/**
 * Skelton Loader
 */
export default {
  name: "SkeltonLoader",
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  props: {
    isLoading: { type: Boolean, required: true, default: false },
    type: { type: String, default: "article" }
  }
};
</script>
